import { API_END_POINT, axiosInstance } from '@app-store'

export const getAwsPermission = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}site-settings`)
}
